import { Component, OnInit } from '@angular/core';
import { ServiceManagerService } from '../service-manager.service';
import { HttpMethod } from '../../constants/constant';
import { HttpCustomOptions } from 'src/services/http-interceptor.service';
import * as jsonexport from 'jsonexport/dist';

@Component({
  selector: 'app-demographic-data',
  templateUrl: './demographic-data.component.html',
  styleUrls: ['./demographic-data.component.scss']
})
export class DemographicDataComponent implements OnInit {
  currentPage: number = 0;
  maxPerPage: number = 20;
  dataList: any[] = [];
  isLoading: boolean = false;
  isSearched: boolean = false;
  searchQuery: string = '';
  totalCount: number = 0;
  searchCount: number = 0;

  constructor(public serviceManager: ServiceManagerService) {}

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    const body = {
      currentpage: this.currentPage,
      maxperpage: this.maxPerPage,
      filters: { search: this.searchQuery.trim() }
    };
    this.serviceManager.CallBackendServiceAPI('demographic-data', body).subscribe((data: any) => {
      this.dataList = data.data_list;
      this.totalCount = data.total_count;
      this.searchCount = data.search_count;
    });
  }

  get totalPages(): number {
    const count = this.isSearched ? this.searchCount : this.totalCount;
    return Math.ceil(count / this.maxPerPage);
  }

  get displayCount(): number {
    return this.isSearched ? this.searchCount : this.totalCount;
  }

  prevPage() {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.getData();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages - 1) {
      this.currentPage++;
      this.getData();
    }
  }

  searchInList() {
    if (!this.searchQuery.trim() && this.isSearched) {
      this.isSearched = false;
      this.currentPage = 0;
      this.getData();
    } else if (this.searchQuery.trim()) {
      this.isSearched = true;
      this.currentPage = 0;
      this.getData();
    }
  }

  clearSearch() {
    this.searchQuery = '';
    if (this.isSearched) {
      this.isSearched = false;
      this.currentPage = 0;
      this.getData();
    }
  }

  downloadCsv() {
    const totalToFetch = this.displayCount;
    if (!totalToFetch) {
      return;
    }
    const body = {
      currentpage: 0,
      maxperpage: totalToFetch,
      filters: { search: this.searchQuery.trim() }
    };
    const customOptions: HttpCustomOptions = {
      showErrorMessage: true,
      showSuccessMessage: false,
      createLoaderAction: true
    };
    this.serviceManager.CallBackendServiceAPI('demographic-data', body, HttpMethod.POST, customOptions)
      .subscribe((data: any) => {
        const rows = (data.data_list || []).map((entry: any) => ({
          'Pseudo Name': entry.pseudo_name || '',
          'Email': entry.email_id || '',
          'Age': entry.age || '',
          'Gender': entry.gender || '',
          'City': entry.city || '',
          'Sexuality': entry.sexuality || '',
          'Created At': entry.created_at ? this.formatDateIST(entry.created_at) : '',
          'Updated At': entry.updated_at ? this.formatDateIST(entry.updated_at) : ''
        }));
        jsonexport(rows, (err: any, csv: string) => {
          if (err) {
            console.error(err);
          } else {
            this.triggerCsvDownload(csv);
          }
        });
      });
  }

  private triggerCsvDownload(csv: string) {
    const blob = new Blob(['﻿', csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'demographic-data.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  formatDateIST(dateStr: string): string {
    if (!dateStr) {
      return '';
    }
    // Backend sends a naive "YYYY-MM-DD HH:mm:ss" string in UTC; mark it
    // explicitly as UTC before converting so the browser doesn't treat it
    // as already being in local time.
    const utcDate = new Date(dateStr.replace(' ', 'T') + 'Z');
    // toLocaleString inserts a comma between date and time (e.g. "06 Aug 2026, 08:38 am"),
    // which breaks CSV column splitting in spreadsheet apps that don't respect quoted fields.
    return utcDate.toLocaleString('en-IN', {
      timeZone: 'Asia/Kolkata',
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).replace(',', '');
  }
}
